import React from 'react';
import { TableRow as MuiTableRow, type TableRowProps } from '@mui/material';

export type DataRowProps = TableRowProps;

export default function DataRow({ children, ...props }: DataRowProps) {
  return <MuiTableRow {...props}>{children}</MuiTableRow>;
}
